import { render, staticRenderFns } from "./importer-form.vue?vue&type=template&id=aa3ffa4c&"
import script from "./importer-form.vue?vue&type=script&lang=js&"
export * from "./importer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports